import { useState } from 'react';

import { useNavigate } from 'react-router-dom';

import BULK_UPLOADER_TITLE from './constants';
import apiConfig from '../../API_Utils/APIUtil/ApiConfig';
import TwoStepUploader from '../../Components/BulkUploader/TwoStepUploader';
import { BULK_UPLOAD_INVOICE_TYPES } from '../../constants';

const steps = [{ title: 'PO Upload' }, { title: 'SKU Upload' }];

const PO = () => {
  const [currentStep, setCurrentStep] = useState(1);
  const naviagate = useNavigate();
  const onNext = () => setCurrentStep(2);

  const firstProps = {
    key: 'po-upload-bulk',
    invoiceType: BULK_UPLOAD_INVOICE_TYPES.DOMESTIC_ONLINE,
    sampleEndpoint: apiConfig.bulkUploader.PO.sample,
    selectionKey: 'po-bulk',
    submitEndpoint: apiConfig.bulkUploader.PO.submit,
    title: 'PO',
    validationEndpoint: apiConfig.bulkUploader.PO.validate,
    onNext: () => onNext(),
    submitButtonText: 'Save & Next'
  };
  const secondProps = {
    key: 'po-bulk',
    invoiceType: BULK_UPLOAD_INVOICE_TYPES.DOMESTIC_ONLINE,
    sampleEndpoint: apiConfig.bulkUploader.PO_SKU.sample,
    selectionKey: 'po-bulk',
    submitEndpoint: apiConfig.bulkUploader.PO_SKU.submit,
    title: 'PO SKU',
    validationEndpoint: apiConfig.bulkUploader.PO_SKU.validate,
    onNext: () => {
      onNext();
      naviagate(0);
    }
  };

  return (
    <TwoStepUploader
      currentStep={currentStep}
      firstProps={firstProps}
      onNext={onNext}
      secondProps={secondProps}
      steps={steps}
      title={BULK_UPLOADER_TITLE.PO}
    />
  );
};

export default PO;
